/**
 * Public pricing page route slugs.
 *
 * These match the URL path segments on hubspot.com/pricing/<slug>.
 * Copied from pricing-pages-lib/constants/PricingPageRoutes — do not import from there.
 */

export const MARKETING = 'marketing';
export const SALES = 'sales';
export const SERVICE = 'service';
export const CMS = 'cms';
export const CONTENT = 'content';
export const OPERATIONS = 'operations';
export const DATA = 'data';
export const CRM = 'crm';
export const SUITE = 'suite';
export const SMART_CRM = 'smart-crm';
export const BUNDLE = 'bundle';
export const COMMERCE = 'commerce';
export const MARKETING_PLUS = 'marketing-plus';
export const ADD_ONS = 'add-ons';
export const HUBSPOT_CREDITS = 'hubspot-credits';

// Experimental, password-gated HSOC preview. Deliberately kept out of
// AllRoutes so it stays outside the product-route + SEO/pre-render pipeline.
export const HSOC_PRICING_PREVIEW = 'hsoc-pricing';
export const AllRoutes = [MARKETING, SALES, SERVICE, CMS, CONTENT, OPERATIONS, DATA, CRM, SUITE, SMART_CRM, BUNDLE, COMMERCE, MARKETING_PLUS, ADD_ONS, HUBSPOT_CREDITS];
const PRICING_PATH_PREFIXES = ['pricing', 'public-pricing'];
function isPublicPricingRoute(value) {
  return AllRoutes.includes(value);
}

/**
 * Maps a URL pathname to a pricing page product route slug.
 * Works for public pages (hubspot.com/pricing/<slug>).
 *
 * Reads the segment immediately after "pricing" or "public-pricing".
 * Returns the slug if it matches AllRoutes, otherwise null.
 */
export const getProductRouteFromPathname = pathname => {
  const segments = pathname.split('/').filter(Boolean);
  const prefixIndex = segments.findIndex(s => PRICING_PATH_PREFIXES.includes(s));
  if (prefixIndex === -1 || prefixIndex + 1 >= segments.length) {
    return null;
  }
  const candidate = segments[prefixIndex + 1];
  return isPublicPricingRoute(candidate) ? candidate : null;
};